<template>
  <div id="foote">
    <div class="footeCon">
      <div style="display: flex; justify-content: space-between">
        <div class="footeLeft">
          <div class="img1">
            <img src="../assets/images/footerImg01.png" alt="" />
          </div>
          <div class="left">
            <p>中国超级物流网络服务商</p>
            <span>客服电话：</span>
            <p>4006—0796—56</p>
            <span>总部地址：江西省吉安市吉州区吉庆路江西数字物流产业园</span>
          </div>
        </div>
        <ul class="footeRight">
          <li>
            <img src="../assets/images/footerImg02.png" alt="" />
            <p>万佶物流公众号</p>
          </li>
          <li style="margin: 0px 40px">
            <img src="../assets/images/footerImg03.png" alt="" />
            <p>业务公众号</p>
          </li>
          <li>
            <img src="../assets/images/footerImg04.png" alt="" />
            <p>江西省省级物流公共信息平台</p>
          </li>
        </ul>
      </div>
      <div class="footeBot">
        <div>
          <a style="padding-left: 0px" href="#">友情链接：</a>
          <a
            v-for="(item, index) in link"
            :key="index"
            target="_blank"
            :href="item.linksurl"
            >{{item.linksname}}
          </a>
         
          <!-- <a target="_blank" href="http://swt.jiangxi.gov.cn/">江西省商务厅</a>
          <a target="_blank" href="http://gxt.jiangxi.gov.cn/"
            >江西省工业和信息化厅</a
          >
          <a target="_blank" href="http://jxf.jiangxi.gov.cn/">江西省财政厅</a>
          <a target="_blank" href="http://www.jxctla.com/">
            江西省交通运输与物流协会</a
          >
          <a target="_blank" href="https://www.jian.gov.cn/">吉安市政府</a>
          
          <a
            style="padding-left: 17px"
            target="_blank"
            href="http://fgw.jian.gov.cn/"
            >吉安市发展和改革委员会</a
          >
          <a target="_blank" href="http://ywl56.com/">运物联官网</a>
          <a
            style="padding-left: 62px"
            target="_blank"
            href="http://jtys.jian.gov.cn/"
            >吉安市交通运输局</a
          >
          <a
            style="padding-left: 77px"
            target="_blank"
            href="http://www.jiangxiwuliu.com"
            >省级公共信息平台官网</a
          > -->
        </div>
        <p style="margin-top: 27px" v-html="version.strcontext">
          <!-- 江西万佶物流有限公司 版权所有 Copyright© {{ year }} All Rights
          Reserved
          <a
            target="_blank"
            style="color: #fff"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            >赣ICP备11004612号-7</a
          > -->
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { setPlatformAPI } from "echarts";
export default {
  name: "foote",
  data() {
    return {
      year: new Date().getFullYear(),
      link: [],
      version:[]
    };
  },
  mounted() {
    setPlatformAPI;
    this.$request({
      url: `/API/Links.aspx?fmtoutput=json`,
      method: "GET",
    }).then(({ data }) => {
      this.link = data.result;
      console.log(data);
      // if (res.data.success) {
      //   // console.log(res.data.result);
      //   if (res.data.result.length && res.data.result[0]) {
      //     this.newesObj = res.data.result[0];
      //     this.newesObj.addtime = this.newesObj.addtime.slice(0, 11);
      //   }
      // }
    });
     this.$request({
        url: `/API/News.aspx?action=default&FmtOutput=json&ClassID=10000044`,
        method: "GET",
      }).then(({ data }) => {
        console.log(data,'data');
       let result= data.result.reverse();
       this.version= result[0]
      });
  },
  methods: {},
};
</script>

<style scoped lang="less">
#foote {
  background: #2a71b8;
  width: 1920px;
  height: 580px;
  margin: auto;
  padding: 105px 0px;
  box-sizing: border-box;
  .footeCon {
    width: 1200px;
    margin: auto;
    font-size: 16px;
    color: #fff;
    .footeLeft {
      display: flex;
      .img1 {
        img {
          width: 120.26px;
          height: 164px;
        }

        margin-right: 17px;
      }
      .left {
        border-left: 1px solid #ccc;
        padding-left: 17px;
      }
      > div {
        p {
          font-size: 30px;
        }
        p:nth-of-type(1) {
          line-height: 30px;
          margin-bottom: 40px;
        }
        p:nth-of-type(2) {
          line-height: 30px;
          margin: 10px 0px;
        }
      }
    }
    .footeRight {
      display: flex;
      justify-content: space-between;
      li {
        img {
          height: 116px;
          width: 116px;
        }
      }
      p {
        width: 116px;
        text-align: center;
      }
    }
    .footeBot {
      width: 100%;
      height: 104px;
      padding: 22px 0px;
      box-sizing: border-box;
      border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;
      margin-top: 45px;
      div {
        display: flex;
        flex-wrap: wrap;
        a {
          color: #fff;
          padding-left: 45px;
          padding-bottom: 12px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/foote.vue